import { useSelector } from "store";
import { isFeatureEnabled } from "utility/isFeatureEnabled";

import type { ReactElement } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";
import type { Options } from "utility/isFeatureEnabled/types/options";

type Props = {
  currentComponent?: ReactElement;
  featureComponent: ReactElement;
} & Omit<Options, "email">;

/**
 * @description
 * src/utility/isFeatureEnabled/index.ts の component 版
 * メアドは store から取得するため props drilling は不要
 * 利用イメージは story 参照
 */
export const FeatureEnabled: FcWithoutChildren<Props> = (props) => {
  const { currentComponent, featureComponent, ...featureOption } = props;
  const email = useSelector((store) => store.auth.user)?.email;

  // NOTE: TypeScriptのdiscriminated unionの制約により型アサーションが必要
  // スプレッド演算子({ email, ...featureOption })を使用すると、
  // TypeScriptは全プロパティのユニオンを持つ単一オブジェクト型として推論し、
  // 各バリアントの必須/オプショナルの制約を正しく理解できない
  // 実行時の型安全性はisFeatureEnabled内のOptionSchema.safeParseで担保される
  // FIXME: 将来的に型アサーションを不要にする方法を検討する
  if (isFeatureEnabled({ email, ...featureOption } as Options))
    return featureComponent;
  return currentComponent ?? null;
};
